import { render, staticRenderFns } from "./ClaimPayoutTable.vue?vue&type=template&id=2865139c&scoped=true"
import script from "./ClaimPayoutTable.vue?vue&type=script&lang=js"
export * from "./ClaimPayoutTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2865139c",
  null
  
)

export default component.exports